import { injectIntl, WrappedComponentProps } from 'react-intl'
import { Col } from 'react-styled-flexboxgrid'
import Flex from 'styled-flex-component'

import TitleBarStyled from '@components/UI/TitleBar/TitleBar.styled'
import { IAnalyticsTrackingContextProps } from '@context/AnalyticsTracking'
import { ICampaignContextProps } from '@context/Campaign'
import { ISubmissionContextProps } from '@context/Submission'
import {
  withAnalyticsTracking,
  withCampaignNoRenderBlock,
  withSubmissionNoRenderBlock,
} from '@hocs'
import hooks from '@hooks'
import { SubmissionTitleBarDesktop } from './Desktop/Desktop'
import { SubmissionTitleBarMobile } from './Mobile'

interface IInternalProps
  extends ICampaignContextProps,
    IAnalyticsTrackingContextProps,
    ISubmissionContextProps,
    WrappedComponentProps {}

export const SubmissionTitleBar = (props: IInternalProps) => {
  const { search } = hooks.useLocation()
  return (
    <TitleBarStyled>
      <Flex alignCenter full>
        <Col xs={false} sm>
          <SubmissionTitleBarDesktop {...props} search={search} />
        </Col>
        <Col xs sm={false}>
          <SubmissionTitleBarMobile {...props} search={search} />
        </Col>
      </Flex>
    </TitleBarStyled>
  )
}

export default withSubmissionNoRenderBlock(
  withCampaignNoRenderBlock(withAnalyticsTracking(injectIntl(SubmissionTitleBar))),
)
